import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import LiveWidgetComponent from './js/live-widget.component';

ComponentsFactory.getInstance().define('live-widget', LiveWidgetComponent);
